<template>
  <div
    v-if="!is2026Version"
    class="certificate-template"
    :class="[isSpecial && 'specialPaper']"
    :style="hgzBg"
  >
    <img
      :src="require(`./static/${isPrint ? 'black' : componentKey}-bg.png`)"
      style="display: none"
      @load="fileLoadFinish('bgImgDemo')"
    />
    <div class="template-box">
      <div v-if="isGreenCertificate" class="template-box_logo">
        <div class="template-box_logo-top">
          <p class="logo-top-img">
            <img
              :src="
                require(`./static/icon-${
                  isPrint ? 'dclshgz2' : certificateInfo.templateKey
                }.png`)
              "
              alt=""
            />
          </p>
          <div class="logo-top-code">
            {{ companyInformationCode }}
          </div>
        </div>
        <div class="template-box_logo-bottom">
          <p class="bottom-title">承诺达标合格证</p>
          <img
            class="bottom-tip"
            :src="
              require(`./static/${isPrint ? 'black' : componentKey}-text.png`)
            "
            alt=""
          />
        </div>
      </div>
      <div v-else class="template-box_title">
        <div class="template-box_title-top">
          <p>承诺达标合格证</p>
        </div>
        <div
          class="template-box_title-bottom"
          :style="{ marginTop: isPrint ? '0' : '4px' }"
        >
          <img
            v-if="!isPrint"
            :src="require(`./static/${certificateInfo.templateKey}-text.png`)"
            alt=""
          />
          <img
            v-else
            :src="
              require(`./static/${
                isLandCertificate
                  ? 'black'
                  : certificateInfo.templateKey + '-black'
              }-text.png`)
            "
            alt=""
          />
        </div>
      </div>
      <div class="template-box_promise">
        <div class="template-box_promise-top">
          <div class="promise-item">
            <p class="promise-item-title">
              我承诺对{{ isLandCertificate ? "生产" : "" }}销售的食用农产品：
            </p>
            <ul>
              <li>
                <p class="promise-item-icon"></p>
                <p class="promise-item-term">
                  {{
                    isLandCertificate
                      ? "不使用禁用农药兽药、停用兽药和非法添加物"
                      : "已收取并保存该批次农产品的承诺达标合格证或者其他质量安全合格证明"
                  }}
                </p>
              </li>
              <li>
                <p class="promise-item-icon"></p>
                <p class="promise-item-term">
                  {{
                    isLandCertificate
                      ? "常规农药兽药残留不超标"
                      : "不违规使用保鲜剂、防腐剂、添加剂等"
                  }}
                </p>
              </li>
              <li>
                <p class="promise-item-icon"></p>
                <p class="promise-item-term">对承诺的真实性负责</p>
              </li>
            </ul>
          </div>
          <div class="promise-item">
            <p class="promise-item-title">承诺依据</p>
            <ul>
              <li>
                <p
                  v-if="!getAttr('cnyj').includes(2)"
                  class="promise-item-icon-normal"
                ></p>
                <p v-else class="promise-item-icon"></p>
                <p class="promise-item-term">质量安全控制符合要求</p>
              </li>
              <li>
                <p
                  v-if="!getAttr('cnyj').includes(1)"
                  class="promise-item-icon-normal"
                ></p>
                <p v-else class="promise-item-icon"></p>
                <p class="promise-item-term">自行检测合格</p>
              </li>
              <li>
                <p
                  v-if="!getAttr('cnyj').includes(0)"
                  class="promise-item-icon-normal"
                ></p>
                <p v-else class="promise-item-icon"></p>
                <p class="promise-item-term">委托检测合格</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="template-box_promise-code">
          <p class="template-box_promise-code-title" v-if="isShowSnlFlag">
            <img
              :src="require(`./static/snl-${isPrint ? 'black' : snlTitle}.png`)"
              alt=""
            />
          </p>
          <p class="template-box_promise-code-title" v-else-if="isShowSnmFlag">
            申农码
          </p>
          <img
            :src="qrcodeVal"
            class="template-box_promise-code-img"
            @load="fileLoadFinish('qrcodeDemo')"
            alt=""
          />
          <!--          <qrcode-vue-->
          <!--            ref="qrcodeRef"-->
          <!--            :value="qrcodeVal"-->
          <!--            :size="120"-->
          <!--            class="template-box_promise-code-img"-->
          <!--          ></qrcode-vue>-->
          <p class="template-box_promise-code-only" v-if="false">
            {{ enterpriseCreditCode }}
          </p>
        </div>
      </div>
      <div
        class="template-box_product"
        :class="[
          isGreenCertificate && 'isGreen',
          !isLandCertificate && 'noLand',
        ]"
      >
        <ul>
          <li>
            <p class="template-box_product-key">产品名称</p>
            <p class="template-box_product-value">
              {{ getAttr("spmc") }}
            </p>
          </li>
          <li>
            <p class="template-box_product-key">重量或数量</p>
            <p class="template-box_product-value">
              {{ getAttr("zl") }}
            </p>
          </li>
          <li>
            <p class="template-box_product-key">产地</p>
            <p class="template-box_product-value">
              {{ getAttr("cd") }}
            </p>
          </li>
          <li v-show="getAttr('qzys') !== '0'">
            <p class="template-box_product-key" style="white-space: nowrap">
              {{ isLandCertificate ? "生产主体" : "收购主体" }}
            </p>
            <p class="template-box_product-value">
              {{ getAttr("qzmc") }}
            </p>
          </li>
          <li>
            <p class="template-box_product-key">联系方式</p>
            <p class="template-box_product-value">
              {{ getAttr("kfdh") }}
            </p>
          </li>
          <li>
            <p class="template-box_product-key">开具日期</p>
            <p class="template-box_product-value">
              {{ getAttr("kjrq").split(".").join("-") }}
            </p>
          </li>
          <li v-if="getAttr('lrsc')">
            <p class="template-box_product-key">流入市场</p>
            <p class="template-box_product-value">
              {{ getAttr("lrsc").split(".").join("-") }}
            </p>
          </li>
        </ul>
        <div v-show="getAttr('qzys') === '1'" class="gongzhang">
          <img :src="sealImg" alt="" @load="fileLoadFinish('sealDemo')" />
        </div>
        <div v-show="getAttr('qzys') === '2'" class="sizhang">
          <img :src="sealImg" alt="" @load="fileLoadFinish('sealDemo')" />
        </div>
        <div v-show="getAttr('qzys') === '3'" class="gongzhang">
          <img :src="sealImg" alt="" @load="fileLoadFinish('sealDemo')" />
        </div>
        <div v-show="getAttr('qzys') === '4'" class="gongzhang">
          <img :src="sealImg" alt="" @load="fileLoadFinish('sealDemo')" />
        </div>
      </div>
      <div class="template-box_footer">
        <p><span class="special">合格证编号：</span>{{ getAttr("hgzbh") }}</p>
        <p
          class="bottom-text"
          v-if="
            shangHaiCertificateSafetyCounty &&
            certificateInfo.templateKey !== 'schgz'
          "
        >
          <i></i><i></i><i></i>{{ shangHaiCertificateSafetyCounty }}<i></i
          ><i></i><i></i>
        </p>
      </div>
    </div>
  </div>
  <component
    v-else
    class="new-certificate-template"
    :is="certificateInfo.templateKey"
    :info="info"
    @load="fileLoadFinish"
  >
  </component>
</template>

<script>
import {
  getSnmQrcodeUrl,
  addCertificateQrcodeUrl,
  getCertificateQrcodeUrl,
  getShangHaiCertificateWhiteConfig,
} from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";
import {
  drawSystemChapter,
  createOfficialSeal,
  createPrivatelySeal,
} from "@/utils/signatureBycanvas";
// import QrcodeVue from "qrcode.vue";
import dcpthgz2026 from "./dcpthgz2026.vue";
import dclshgz12026 from "./dclshgz12026.vue";
import dclshgz22026 from "./dclshgz22026.vue";
import cgpthgz2026 from "./cgpthgz2026.vue";
import cglshgz12026 from "./cglshgz12026.vue";
import cglshgz22026 from "./cglshgz22026.vue";
import schgz2026 from "./schgz2026.vue";
import QRcode from "qrcode";

const { supervisionFlag, enterpriseCreditCode } =
  getStorage("COMPANYINFO") || "";
const snmTemplate = [
  "hgzys3",
  "hgzys4",
  "hgzys5",
  "dcpthgz",
  "dclshgz1",
  "dclshgz2",
  "wchgz",
  "dcpthgz2026",
  "dclshgz12026",
  "dclshgz22026",
  "cgpthgz2026",
  "cglshgz12026",
  "cglshgz22026",
];

const hgzColorMap = {
  dcpthgz: "#009a53",
  dclshgz1: "#009a53",
  dclshgz2: "#000",
  wchgz: "#2b6193",
  schgz: "#b18448",
  dcpthgz2026: "#009a53",
  dclshgz12026: "#009a53",
  dclshgz22026: "#000",
  cgpthgz2026: "#2b6193",
  cglshgz12026: "#2b6193",
  cglshgz22026: "#000",
  schgz2026: "#b18448",
};

const hgzBgColorMap = {
  dcpthgz: "#f0f9f5",
  dclshgz1: "#f0f9f5",
  dclshgz2: "#fff",
  wchgz: "#f6fbff",
  schgz: "#fffbf6",
  dcpthgz2026: "#f0f9f5",
  dclshgz12026: "#f0f9f5",
  dclshgz22026: "#fff",
  cgpthgz2026: "#f6fbff",
  cglshgz12026: "#f6fbff",
  cglshgz22026: "#fff",
  schgz2026: "#fffbf6",
};

const hgzSNBgColorMap = {
  dcpthgz: "#D3F3D5",
  dclshgz1: "#D3F3D5",
  dclshgz2: "#c2c2c2",
  wchgz: "#CDDCE9",
  schgz: "#FAEEDF",
  dcpthgz2026: "#D3F3D5",
  dclshgz12026: "#D3F3D5",
  dclshgz22026: "#c2c2c2",
  cgpthgz2026: "#CDDCE9",
  cglshgz12026: "#CDDCE9",
  cglshgz22026: "#c2c2c2",
  schgz2026: "#FAEEDF",
};

const hgzSNLTitleMap = {
  dcpthgz: "green",
  dclshgz1: "green",
  dclshgz2: "black",
  wchgz: "wc",
  schgz: "sc",
};

const hgzTypeMap = {
  schgz: "schgz",
  wchgz: "wchgz",
  dcpthgz: "dcpthgz",
  dclshgz1: "dcpthgz",
  dclshgz2: "black",
  dcpthgz2026: "dcpthgz2026",
  dclshgz12026: "dclshgz12026",
  dclshgz22026: "dclshgz22026",
  cgpthgz2026: "cgpthgz2026",
  cglshgz12026: "cglshgz12026",
  cglshgz22026: "cglshgz22026",
  schgz2026: "schgz2026",
};

export default {
  name: "index",
  components: {
    // QrcodeVue,
    dcpthgz2026,
    dclshgz12026,
    dclshgz22026,
    cgpthgz2026,
    cglshgz12026,
    cglshgz22026,
    schgz2026,
  },
  props: {
    certificateData: {
      type: Object,
      default: () => {},
    },
    templateType: {
      type: String,
      default: "",
    },
    zoom: {
      type: Number,
      default: 1,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    is2026Version() {
      return [
        "dcpthgz2026",
        "dclshgz12026",
        "dclshgz22026",
        "cgpthgz2026",
        "cglshgz12026",
        "cglshgz22026",
        "schgz2026",
      ].includes(this.certificateInfo.templateKey);
    },
    info() {
      return {
        ...this.certificateData,
        qrCodeUrl: this.qrcodeVal,
        sealImg: this.sealImg,
      };
    },
    isSpecial() {
      return this.certificateData.specialPaper && this.isPrint;
    },
    componentKey() {
      return hgzTypeMap[this.certificateInfo.templateKey];
    },
    snlTitle() {
      return hgzSNLTitleMap[this.certificateInfo.templateKey];
    },
    isGreenCertificate() {
      const key = this.certificateInfo.templateKey;
      return [
        "dclshgz1",
        "dclshgz2",
        "dclshgz12026",
        "dclshgz22026",
        "cglshgz12026",
        "cglshgz22026",
      ].includes(key);
    },
    isLandCertificate() {
      const key = this.certificateInfo.templateKey;
      return [
        "dclshgz1",
        "dclshgz2",
        "dcpthgz",
        "dcpthgz2026",
        "dclshgz12026",
        "dclshgz22026",
      ].includes(key);
    },
    certificateInfo() {
      return this.certificateData.certificateTemplate;
    },
    attrRespList() {
      return this.certificateData.attrRespList;
    },
    companyInformationCode() {
      return this.certificateData.companyInformationCode;
    },
    hgzBg() {
      const key = this.isSpecial
        ? "print-gou"
        : this.isPrint
        ? "print"
        : this.componentKey;
      return {
        zoom: this.zoom,
        "--hgzFooterHeight": this.isGreenCertificate ? "26px" : "29px",
        "--hgzColor": this.isPrint
          ? "#000"
          : hgzColorMap[this.certificateInfo.templateKey],
        "--hgzBgColor": this.isPrint
          ? "#fff"
          : hgzBgColorMap[this.certificateInfo.templateKey],
        "--hgzSNBgColorMap": this.isPrint
          ? "#D3F3D5"
          : hgzSNBgColorMap[this.certificateInfo.templateKey],
        "--selectImg": `url(${require(`./static/${key}-check.png`)})`,
        "--normalImg": this.isSpecial
          ? ""
          : `url(${require(`./static/${key}-normal.png`)})`,
        "--cellSpace":
          this.getAttr("qzmc").length > 15 && this.isGreenCertificate
            ? "1px"
            : this.isGreenCertificate
            ? "2px"
            : "6px",
        backgroundImage: this.isSpecial
          ? "none"
          : `url(${require(`./static/${
              this.isPrint ? "black" : this.componentKey
            }-bg.png`)})`,
      };
    },
    c_isShowSnm() {
      const { countyId } = getStorage("FARMINFO");
      let isSimpleCert = Number(this.certificateInfo.templateType) === 2; //合格证类型，默认1（1：产销合格证默认，2：简易合格证））
      //申农码条件：上海 && 监管 && 合格证样式是【标准，绿色彩色，绿色黑白】之一 ，使用带中心图片二维码，同时使用新二维码链接
      const sheNongQu = [
        310120, //310120 奉贤区
        310112, //310112 闵行区
        310113, //310113 宝山区
        310118, //310118 青浦区
        310114, //嘉定区
        310116, //金山区
        310115, //浦东新区
        310117, //松江区
        310230, //崇明区
        310181, //光明
        310182, //上实
        310183, //地产
      ].map((id) => id.toString());
      const isSnmQrCode =
        sheNongQu.includes(countyId.toString()) &&
        supervisionFlag &&
        snmTemplate.includes(this.certificateInfo.templateKey) &&
        enterpriseCreditCode;
      return isSnmQrCode && !isSimpleCert;
    },
    certificateType() {
      switch (this.certificateInfo.templateKey) {
        default:
        case "wchgz":
          return 1;
        case "dcpthgz":
          return 2;
        case "dclshgz1":
        case "dclshgz2":
          return 3;
        case "cgpthgz2026":
          return 4;
        case "cglshgz12026":
        case "cglshgz22026":
          return 5;
        case "dcpthgz2026":
          return 6;
        case "dclshgz12026":
        case "dclshgz22026":
          return 7;
      }
    },
  },
  data() {
    return {
      templateList: ["dcpthgz", "dclshgz1", "dclshgz2", "wchgz", "schgz"],
      qrcodeVal: "",
      sealImg: "",
      qrcodeDemo: false,
      sealDemo: false,
      bgImgDemo: false,
      shangHaiCertificateSafetyCounty: "",
      isShowSnmFlag: false,
      isShowSnlFlag: false,
      // 科技兴农白名单: 开启-走非申农码、关闭-走原有逻辑
      notSnmLogic: false,
    };
  },
  // watch: {
  //   certificateData(newVal) {
  //     if (newVal) {
  //       this.createQrcode();
  //       this.creatSign();
  //     }
  //   },
  // },
  created() {
    this.createQrcode();
    this.creatSign();
    this.fetchShangHaiCertificateSafetyCountyText();
  },
  methods: {
    getAttr(key) {
      return this.attrRespList.filter((i) => i.attrKey === key)[0]?.attrVal;
    },
    async createQrcode() {
      const { farmName } = getStorage("FARMINFO");
      const certificateNo = this.getAttr("hgzbh");
      let codeUrlTxt = `${process.env.VUE_APP_HGZ}/#/home/hgz/${certificateNo}`;
      // 科技兴农白名单(上海)
      this.notSnmLogic = await this.fetchTechnicalAbriWhiteUrl();
      const { obj: certificateQrCodUrlRes } = await getCertificateQrcodeUrl({
        certificateNo,
      });
      this.isShowSnlFlag = certificateQrCodUrlRes.type === "SHENON_CHAIN_CODE";
      // 最高优先级二维码逻辑（getQRCodeUrl 已查询，certificateQrCodUrlRes 复用）
      const highPriorityRes = await this.resolveHighPriorityQrUrl({
        certificateQrCodUrlRes,
        certificateNo,
        templateKey: this.certificateInfo.templateKey,
        cropId: this.certificateData.cropId,
      });
      if (highPriorityRes) {
        codeUrlTxt = highPriorityRes.url;
        // 命中最高优先级：getQRCodeUrl 有数据保持原标志；否则(走左岸码)不显示申农码样式
        if (
          !(
            certificateQrCodUrlRes &&
            certificateQrCodUrlRes.type &&
            certificateQrCodUrlRes.qrcodeUrl
          )
        ) {
          this.isShowSnmFlag = false;
        }
      } else if (certificateQrCodUrlRes.qrcodeUrl || this.isShowSnlFlag) {
        codeUrlTxt = certificateQrCodUrlRes.qrcodeUrl;
        this.isShowSnmFlag = certificateQrCodUrlRes.type === "SHENON_CODE";
      } else {
        if (this.c_isShowSnm && !this.notSnmLogic) {
          const params = {
            type: 6, //理想要求的
            ztCode: enterpriseCreditCode,
            code: certificateNo,
            dkid: "",
            pch: "",
            productName: this.getAttr("spmc"),
            production: this.getAttr("zl"),
            productAddr: this.getAttr("cd"),
            tel: this.getAttr("kfdh"),
            signature: this.getAttr("qzmc"),
            openDate: this.getAttr("kjrq"),
            ztName: farmName,
            // 添加参数
            isSafe: Number(this.getAttr("cnyj").includes(2)),
            selfQualified: Number(this.getAttr("cnyj").includes(1)),
            entrustQualified: Number(this.getAttr("cnyj").includes(0)),
            certificateType: this.certificateType, // 合格证类型（1外采型，2地产型，3绿色地产型 4 采购普通2026 5采购绿色2026 6地产普通2026 7地产绿色2026）
          };
          const { obj } = await getSnmQrcodeUrl(params);
          codeUrlTxt = `${obj}`;
          this.isShowSnmFlag = true;
        }
        await addCertificateQrcodeUrl({
          certificateNo,
          qrcodeUrl: codeUrlTxt,
          qrCodeSourceEnum:
            this.extractDomain(codeUrlTxt) === "qrcode.sh.gov.cn"
              ? "SHENON_CODE"
              : "ZUOAN_CODE",
        });
      }

      // 上海地区：生成合格证二维码短链接(扫描二维码跳转溯源固定短链接，通过合格证编号获取真实链接再做跳转)
      // if (Number(provinceId) === 310000) {
      //   const certificateCode = certificateNo;
      //   const qrcodeType = this.isShowSnmFlag ? 2 : 1;
      //   const certificateQRCodeShortLinkParams = {
      //     certificateCode,
      //     qrcodeType,
      //     linkUrl: codeUrlTxt,
      //   };
      //   const { respCode, obj: certificateId } =
      //     await addCertificateQRCodeShortLink(certificateQRCodeShortLinkParams);
      //   if (respCode === 0) {
      //     codeUrlTxt = `${process.env.VUE_APP_SH_CERTIFICATE_CODE_URL}?p=${qrcodeType}_$_${certificateId}`;
      //   }
      // }

      QRcode.toDataURL(
        encodeURI(codeUrlTxt),
        {
          errorCorrectionLevel: "H",
          type: "image/jpeg",
          margin: 0,
          width: 196,
        },
        (err, url) => {
          if (err) throw err;
          this.qrcodeVal = url;
        }
      );
      // this.$nextTick(() => {
      //   this.fileLoadFinish("qrcodeDemo");
      // });
    },
    creatSign() {
      let hgzColor = ["dclshgz2", "dclshgz22026", "cglshgz22026"].includes(
        this.certificateInfo.templateKey
      )
        ? "#808080"
        : "#ED1C24";
      if (this.certificateInfo.templateColor === 1) {
        hgzColor = "#000";
      }
      if (this.getAttr("qzys") === "1") {
        createOfficialSeal(this.getAttr("qzmc"), hgzColor).then((res) => {
          this.sealImg = res;
        });
      }
      if (this.getAttr("qzys") === "2") {
        createPrivatelySeal(this.getAttr("qzmc"), hgzColor).then((res) => {
          this.sealImg = res;
        });
      }
      if (this.getAttr("qzys") === "3") {
        const { signUrl } = getStorage("FARMINFO");
        this.sealImg = signUrl;
      }
      if (this.getAttr("qzys") === "0") {
        this.fileLoadFinish("sealDemo");
      }
      if (this.getAttr("qzys") === "4") {
        drawSystemChapter(this.getAttr("qzmc"), hgzColor).then((res) => {
          this.sealImg = res;
        });
      }
    },
    fileLoadFinish(type) {
      this[type] = true;
      this.$emit("load", this.qrcodeDemo && this.sealDemo && this.bgImgDemo);
    },
    fetchShangHaiCertificateSafetyCountyText() {
      const farmInfo = JSON.parse(localStorage.getItem("FARMINFO"));
      // 主体在以下6个区[浦东、嘉定、金山、崇明、青浦、松江]合格证上内容为“产自国家农产品质量安全县”;
      const countyIds_1 = [
        310115, // 浦东新区
        310114, // 嘉定区
        310116, // 金山区
        310230, // 崇明区
        310118, // 青浦区
        310117, // 松江区
      ];
      // 主体在以下6个区[奉贤、宝山、闵行、光明、上实、地产]合格证上内容为 “积极创建国家农产品质量安全县”;
      const countyIds_2 = [
        310120, // 奉贤区
        310113, // 宝山区
        310112, // 闵行区
        310181, // 光明
        310182, // 上实
        310183, // 地产
      ];

      if (Number(farmInfo.provinceId) !== 310000) return;

      this.shangHaiCertificateSafetyCounty = countyIds_1.includes(
        Number(farmInfo.countyId)
      )
        ? "产自国家农产品质量安全县"
        : countyIds_2.includes(Number(farmInfo.countyId))
        ? "积极创建国家农产品质量安全县"
        : "";
    },
    extractDomain(url) {
      let domain = null;
      // 查找并提取域名
      let match = url.match(
        /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?=]+)?/i
      );
      if (match && match[1]) {
        domain = match[1];
      }
      return domain;
    },
    /**
     * @description 科技兴农白名单(如果开启了科技兴农白名单，合格证所有二维码url都在溯源H5，这个开关条件是高于申农码条件的)
     * @returns { Boolean } true-开启、false-关闭
     */
    async fetchTechnicalAbriWhiteUrl() {
      const { respCode, obj: result } =
        await getShangHaiCertificateWhiteConfig();
      const status = Boolean(
        result?.detailVOS?.find((item) => Number(item.type) === 12)?.elements
          ?.length
      );

      if (respCode === 0) return status;

      return;
    },
    /**
     * @description 最高优先级二维码逻辑：getQRCodeUrl 有数据用返回链接；否则按 type=19 白名单
     * (开具日期 + web平台 + 证书类型 + 作物id) 级联判断，命中则赋值为左岸码链接
     * @returns { {url:string}|null } 命中返回 { url }，未命中返回 null（走原有逻辑）
     */
    async resolveHighPriorityQrUrl({
      certificateQrCodUrlRes,
      certificateNo,
      templateKey,
      cropId,
    }) {
      // 地产型 / 采购型 证书类型 key
      const DC_KEYS = [
        "dcpthgz2026",
        "dclshgz12026",
        "dclshgz22026",
        "dcpthgz",
        "dclshgz1",
        "dclshgz2",
      ];
      const CG_KEYS = [
        "cgpthgz2026",
        "cglshgz12026",
        "cglshgz22026",
        "schgz2026",
        "wchgz",
        "schgz",
      ];
      // 左岸码链接
      const zuoAnUrl = `${process.env.VUE_APP_HGZ}/#/home/hgz/${certificateNo}`;

      // 步骤1：getQRCodeUrl 有数据 → 用返回链接（最高优先级）
      if (
        certificateQrCodUrlRes &&
        certificateQrCodUrlRes.type &&
        certificateQrCodUrlRes.qrcodeUrl
      ) {
        return { url: certificateQrCodUrlRes.qrcodeUrl };
      }
      // 步骤2：单独调用白名单接口，取 type=19 项
      const { obj: whiteResult } = await getShangHaiCertificateWhiteConfig();
      const type19 = whiteResult?.detailVOS?.find(
        (item) => Number(item.type) === 19
      );
      if (!type19) return null;
      const alternateDate = type19.alternateField; // YYYY-MM-DD
      const issueDate = (this.getAttr("kjrq") || "").replace(/\./g, "-"); // 点转横线，统一格式
      if (!alternateDate || !issueDate) return null;
      if (alternateDate > issueDate) return null; // 日期大于开具日期 → 走原有逻辑
      // 步骤3：elements 平台判断（当前为 web 端，判断 -1）
      const elements = type19.elements || [];
      if (!elements.includes(-1)) return null;
      // 步骤4：elements 证书类型判断（地产型 -3 / 采购型 -4）
      if (DC_KEYS.includes(templateKey)) {
        if (!elements.includes(-3)) return null;
      } else if (CG_KEYS.includes(templateKey)) {
        if (!elements.includes(-4)) return null;
      } else {
        return null;
      }
      // 步骤5：作物 id 判断（最终层），命中则赋值为左岸码链接
      if (cropId != null && elements.includes(cropId)) {
        return { url: zuoAnUrl };
      }
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
.new-certificate-template {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  margin: 0 auto;
  width: 450px;
  height: 670px;
  padding: 12px 22px 10px;
  box-sizing: border-box;
  box-shadow: 0 0 5px 1px rgba(4, 0, 0, 0.06);
  // background: url("./static/dcpthgz-bg.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: top left;
}
.certificate-template {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  margin: 0 auto;
  width: 450px;
  height: 670px;
  padding: 12px 22px 10px;
  box-sizing: border-box;
  box-shadow: 0 0 5px 1px rgba(4, 0, 0, 0.06);
  background: url("./static/dcpthgz-bg.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: top left;
  .template-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    &_logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      &-top {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        .logo-top-img {
          width: 92px;
          height: 124px;
          box-sizing: border-box;
          img {
            height: 100%;
            width: 100%;
            vertical-align: middle;
          }
        }
        .logo-top-code {
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          color: #000000;
          width: 100%;
          text-align: center;
        }
      }
      &-bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        .bottom-title {
          font-style: normal;
          font-weight: 700;
          font-size: 32px;
          line-height: 46px;
          color: var(--hgzColor);
          margin-right: 20px;
        }
        .bottom-tip {
          height: 30px;
          width: 90px;
        }
      }
    }
    &_title {
      display: flex;
      flex-direction: column;
      align-items: center;
      &-top {
        p {
          font-style: normal;
          font-weight: 700;
          font-size: 40px;
          line-height: 58px;
          color: var(--hgzColor);
        }
      }
      &-bottom {
        img {
          height: 30px;
          width: 90px;
          vertical-align: middle;
        }
      }
    }
    &_product {
      display: flex;
      position: relative;
      flex-direction: column;
      margin-bottom: var(--cellSpace);
      width: 100%;
      .gongzhang {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        img {
          height: 150px;
          width: 150px;
          vertical-align: middle;
        }
      }
      .sizhang {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) rotate(-15deg);
        img {
          height: 45px;
          vertical-align: middle;
        }
      }
      &.isGreen {
        .template-box_product-key {
          line-height: 22px;
        }
        .template-box_product-value {
          line-height: 22px;
        }
        ul {
          row-gap: 2px;
        }
      }
      &.noLand {
        .template-box_product-key {
          line-height: 24px;
        }
        .template-box_product-value {
          line-height: 24px;
        }
        ul {
          row-gap: 3px;
        }
      }
      &-key {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #231815;
      }
      &-value {
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 26px;
        color: #231815;
        text-align: right;
      }
      ul {
        display: flex;
        flex-direction: column;
        row-gap: 4px;
      }
      li {
        display: flex;
        column-gap: 10px;
        width: 100%;
        justify-content: space-between;
      }
    }
    &_promise {
      display: flex;
      flex-direction: column;
      width: 100%;
      background-color: var(--hgzBgColor);
      padding: 8px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: var(--cellSpace);
      &-code {
        position: absolute;
        bottom: 8px;
        right: 8px;
        //padding: 4px;
        box-sizing: border-box;
        height: 164px;
        width: 152px;
        //background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &-title {
          font-style: normal;
          font-weight: 600;
          font-size: 24px;
          background-color: var(--hgzSNBgColorMap);
          border-radius: 0 12px 0 12px;
          width: 133px;
          text-align: center;
          color: var(--hgzColor);
          height: 26px;
          line-height: 26px;
          margin-bottom: 5px;
          img {
            width: 70%;
          }
        }
        &-img {
          height: 140px;
          width: 140px;
          img {
            height: 100%;
            width: 100%;
            vertical-align: middle;
          }
        }
        &-only {
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          color: #000000;
        }
      }
      &-top {
        display: flex;
        flex-direction: column;
        row-gap: var(--cellSpace);
        .promise-item {
          display: flex;
          flex-direction: column;
          &-title {
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 32px;
            margin-bottom: var(--cellSpace);
            color: var(--hgzColor);
          }
          &-term {
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 26px;
            color: #231815;
            display: flex;
            width: calc(100% - 22px);
            flex-wrap: wrap;
          }
          &-icon {
            height: 22px;
            width: 22px;
            background: var(--selectImg) no-repeat center;
            background-size: 100% 100%;
            margin-right: 8px;
            box-sizing: border-box;
          }
          &-icon-normal {
            height: 22px;
            width: 22px;
            background: var(--normalImg) no-repeat center;
            background-size: 100% 100%;
            margin-right: 8px;
            box-sizing: border-box;
          }
          ul {
            display: flex;
            flex-direction: column;
            row-gap: var(--cellSpace);
          }
          li {
            display: flex;
            align-items: center;
          }
        }
      }
    }
    &_footer {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: var(--hgzFooterHeight);
      color: var(--hgzColor);
      text-align: center;
      .bottom-text {
        display: flex;
        align-items: center;
        color: #6e737b;
        i {
          border: 6px solid #6e737b;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
        }
        i:nth-child(-n + 3) {
          border-right: 6px solid transparent;
        }
        i:nth-last-child(-n + 3) {
          border-left: 6px solid transparent;
        }
      }
    }
  }
  &.specialPaper {
    .template-box_title,
    .template-box_product-key,
    .promise-item-title,
    .special,
    .logo-top-img,
    .template-box_logo-bottom,
    .promise-item-term {
      opacity: 0;
    }
    .template-box_promise {
      background-color: #fff;
    }
    .promise-item-icon-normal {
      background-image: none;
    }
    .template-box_product {
      ul {
        li:nth-child(4) {
          .template-box_product-value {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: -3px;
          }
        }
      }
    }
  }
}
</style>
